module.exports = __webpack_public_path__ + "static/media/7a.253fc766.ogg";